import { Permission } from '@/graphql/types';
import { hasAtLeastPermission } from '../sharing/utils';

export function canEditReportTemplate(permission: Permission): boolean {
    return hasAtLeastPermission(permission, Permission.FullAccess);
}
